// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {  connectFirestoreEmulator, getFirestore, doc, setDoc, getDoc, addDoc, collection } from "firebase/firestore";
import { getAuth, signInAnonymously } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBsyS0XZaIZH88q1ltUgUgPBGHhCPX8kJQ",
  authDomain: "clgmbh-preisanfrage-formular.firebaseapp.com",
  projectId: "clgmbh-preisanfrage-formular",
  storageBucket: "clgmbh-preisanfrage-formular.appspot.com",
  messagingSenderId: "731792585694",
  appId: "1:731792585694:web:cb4cec66bf4cf3c928234f"
};

// Initialize Firebase
initializeApp(firebaseConfig);

const firestore = getFirestore();

if (location.hostname === "localhost") {
  connectFirestoreEmulator(firestore, 'localhost', 8082);
}

export {
  firestore,
  doc,
  setDoc,
  getDoc,
  addDoc,
  collection,
  getAuth, 
  signInAnonymously
}